import { render } from "./MainHeader.vue?vue&type=template&id=8b622edc"
import script from "./MainHeader.vue?vue&type=script&lang=js"
export * from "./MainHeader.vue?vue&type=script&lang=js"

import "@/assets/styles/layout/header.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__